import React, { useEffect, useState } from "react";
import "./header.scss";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../Images/logo3.png";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../utils/store/slice/userSlice";
import { signOut } from "firebase/auth";
import { auth } from "../../utils/firebase";
import { FiLogOut } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import openai from "../../utils/openAI";
import { TMDBOptions } from "../../utils/tmdbOption";
import { setMoviesByName } from "../../utils/store/slice/movieSlice";
import {
  clearErrorMessage,
  setOpenAIError,
} from "../../utils/store/slice/errorSlice";
import Swal from "sweetalert2";
import MoodModal from "./MoodModal";
import {
  setPendingFalse,
  setPendingTrue,
} from "../../utils/store/slice/pendingSlice";
import PendingModal from "./PendingModal";
import Joyride from "react-joyride";

const Header = () => {
  const [isDisplayToggle, setIsDisplayToggle] = useState(false);
  const [promptText, setPromptText] = useState("");
  const [runTour, setRunTour] = useState(false);
  const [modal, setModal] = useState(false);
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const errorMessage = useSelector((state) => state.error?.openAIApiError);
  const dispatch = useDispatch();

  useEffect(() => setRunTour(true), []);
  
  useEffect(() => {
    function handleResize() {
      setIsMobileView(window.innerWidth < 768);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (errorMessage !== null) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: errorMessage,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(clearErrorMessage());
      }
    });
  }

  const handleLogout = () => {
    setIsDisplayToggle(false);
    signOut(auth)
      .then(() => {
        dispatch(removeUser());
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleMoodSelection = (mood) => {
    handleSearchPrompt(mood);
    toggle();
  };

  const handleMovieSearch = async (movieName) => {
    const data = await fetch(
      `https://api.themoviedb.org/3/search/movie?query=${movieName}&include_adult=false&language=en-US&page=1`,
      TMDBOptions
    );
    const json = await data.json();
    const filteredMovies = json?.results?.filter((result) => {
      return result.length !== 0;
    });
    return filteredMovies;
  };

  const handleSearchPrompt = async (mood) => {
    dispatch(setPendingTrue(true));
    const moodQuery =
      "Act as a recommendation system and suggest some movies for this query: the user is in" +
      mood +
      "mood please suggest some good movies so that his/her mood can change. Only give me 10 movies with comma separated like given example ahead. Example: Sholay, Gadar, Krish, Don, Kabhi Khushi Kabhie Gham";

    const searchQuery =
      "Act as a recommendation system and suggest some movies for this query: " +
      promptText +
      ". Only give me 10 movies with comma separated like given example ahead. Example: Sholay, Gadar, Krish, Don, Kabhi Khushi Kabhie Gham";
    try {
      const chatCompletion = await openai.chat.completions.create({
        messages: [{ role: "user", content: mood ? moodQuery : searchQuery }],
        model: "gpt-4",
      });

      const openAIMovies =
        chatCompletion.choices?.[0]?.message?.content.split(",");

      if (
        openAIMovies[0].includes("As an AI") ||
        openAIMovies[0].includes("I'm sorry") ||
        openAIMovies[0].includes("Sorry")
      ) {
        dispatch(
          setOpenAIError(
            "There is an error while fetching movies. Please try again or try to change the prompt."
          )
        );
        return;
      }

      const promiseArray = openAIMovies?.map(async (movie) => {
        return await handleMovieSearch(movie);
      });

      const openAIresults = await Promise.all(promiseArray);

      const finalMovies = openAIresults?.map((movies) => {
        return movies[0];
      });
      dispatch(setMoviesByName(finalMovies));
    } catch (error) {
      console.log(error);
      dispatch(
        setOpenAIError(
          "There is an error while fetching movies. Please try again or try to change the prompt."
        )
      );
    } finally {
      dispatch(setPendingFalse(false));
    }
  };

  const toggle = () => setModal((prev) => !prev);

  const steps = isMobileView
    ? [
        {
          target: ".search-mobile-input",
          content:
            "Use this search bar to find movies based on your mood or a specific query.",
          placement: "bottom",
        },
        {
          target: ".mood-btn",
          content:
            "Click here to select a mood and get movie recommendations tailored to how you feel.",
          placement: "bottom",
        },
        {
          target: ".login",
          content: "Click here to login to your account",
          placement: "bottom",
        },
      ]
    : [
        {
          target: ".search-input",
          content:
            "Use this search bar to find movies based on your mood or a specific query.",
          placement: "bottom",
        },
        {
          target: ".mood-btn",
          content:
            "Click here to select a mood and get movie recommendations tailored to how you feel.",
          placement: "bottom",
        },
        {
          target: ".login",
          content: "Click here to login to your account",
          placement: "bottom",
        },
      ];

  return (
    <>
      <Joyride
        continuous={true}
        run={runTour}
        steps={steps}
        scrollToFirstStep={true}
        showProgress={true}
        showSkipButton={true}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      <div className="header">
        <Link to="/browse">
          <img src={Logo} alt="Hotflix Logo" className="header-logo" />
        </Link>
        <div className="flex items-center">
          {(location.pathname === "/" || location.pathname === "/browse") && (
            <>
              <div className="mr-10 md:block hidden search-input">
                <input
                  placeholder="Enter prompt"
                  value={promptText}
                  name="prompt"
                  onChange={(e) => setPromptText(e.target.value)}
                />
                <button
                  style={{ textDecoration: "none" }}
                  className="search-btn"
                  onClick={() => {
                    handleSearchPrompt();
                  }}
                >
                  Search
                </button>
              </div>
              <button
                style={{ textDecoration: "none" }}
                className="mood-btn"
                onClick={() => {
                  toggle();
                }}
              >
                Mood
              </button>

              <MoodModal
                modal={modal}
                toggle={toggle}
                handleMoodSelection={handleMoodSelection}
              />
              <PendingModal />
            </>
          )}
          {user?.email ? (
            <p
              className="text-white text-4xl cursor-pointer relative"
              onClick={() => setIsDisplayToggle(!isDisplayToggle)}
            >
              {user?.displayName ? user.displayName : "user"}
            </p>
          ) : (
            <Link to="/login">
              <button
                style={{ textDecoration: "none" }}
                className="btn m-0 login"
              >
                Log in
              </button>
            </Link>
          )}
        </div>

        {isDisplayToggle && (
          <div className="px-10 py-5 bg-white absolute top-28 right-3 z-20 text-nowrap gap-4 flex flex-col rounded-md">
            <h2 className="font-bold text-left text-3xl">welcome!</h2>
            <hr className="border-t-2" />
            <Link
              to="/login"
              style={{ textDecoration: "none" }}
              className="text-2xl flex items-center"
              onClick={() => {
                handleLogout();
              }}
            >
              <FiLogOut size={24} />{" "}
              <span className="text-slate-950">Log out</span>
            </Link>
            <hr className="border-t-2" />
            <Link
              to="/favourite_movies"
              style={{ textDecoration: "none" }}
              className="text-2xl flex items-center"
            >
              <FaHeart size={24} color="red" />{" "}
              <span className="text-slate-950">Favourite Movies</span>
            </Link>
          </div>
        )}
      </div>
      {(location.pathname === "/" || location.pathname === "/browse") && (
        <div className="flex items-center justify-center p-5 md:hidden search-mobile-input">
          <input
            placeholder="Enter prompt"
            value={promptText}
            name="prompt"
            onChange={(e) => setPromptText(e.target.value)}
          />
          <button
            style={{ textDecoration: "none" }}
            className="search-btn"
            onClick={() => {
              handleSearchPrompt();
            }}
          >
            Search
          </button>
        </div>
      )}
    </>
  );
};

export default Header;
